export default __webpack_public_path__ + "static/media/group.3be51452.svg";